import _ from "lodash";
import moment from "moment";
import React from "react";
import { useMutation, useQuery } from "react-apollo";
import SweetAlert from "react-bootstrap-sweetalert";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import {
  Button,
  ButtonDropdown,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Admin,
  Developer,
  OperatingUsers,
} from "../../assets/scss/role.constant";
import {
  APPROVE_ONE_WITHDRAWAL,
  CALCULATE_REWARD_POINT,
  CHANGE_COMPANY_BANK_ACCOUNT,
  PROCESS_ONE_CREDITIN,
  PROCESS_ONE_CREDITOUT,
  REJECT_ONE_DEPOSIT,
  REJECT_ONE_WITHDRAWAL,
  VIEW_ONE_TRANSACTION,
} from "../../graphql/mutation";
import { APPROVE_ONE_DEPOSIT } from "../../graphql/mutation/APPROVE_ONE_DEPOSIT";
import { CALCULATE_AGENT_POINT } from "../../graphql/mutation/CALCULATE_AGENT_POINT";
import { CHECK_PAYMENT_STATUS } from "../../graphql/mutation/CHECK_PAYMENT_STATUS";
import { CHECK_RELEASE_PAYMENT_STATUS } from "../../graphql/mutation/CHECK_RELEASE_PAYMENT_STATUS";
import { ON_HOLD_ONE_TRANSACTION } from "../../graphql/mutation/ON_HOLD_ONE_TRANSACTION";
import { RELEASE_PAYMENT } from "../../graphql/mutation/RELEASE_PAYMENT";
import { UPDATE_ONE_TRANSACTION } from "../../graphql/mutation/UPDATE_ONE_TRANSACTION";
import { ME } from "../../graphql/query";
import { GET_ENUM } from "../../graphql/query/GET_ENUM";
import { GET_PAYMENT_TYPES } from "../../graphql/query/GET_PAYMENT_TYPES";
import ToastHelper from "../../helpers/ToastHelper";
import WithdrawBank from "../Banking/withdraw-bank";
import TransactionChangeBank from "./transaction-change-bank";
import TransactionReject from "./transaction-reject";

function TransactionItem(props) {
  const {
    transaction,
    onDone,
    type,
    onManageInWorkbench,
    onDelete,
    showReject,
    isAtDashboard,
    hasPaidAt,
    isFromWorkflow,
    allowSupersede,
    onSupersede,
  } = props;
  const [drp_link, setDrpLink] = React.useState(false);
  const [isWithdrawal, setIsWithdrawal] = React.useState(false);
  const [isReject, setIsReject] = React.useState(false);
  const [isDepost, setIsDeposit] = React.useState(false);
  const [isCalculateRp, setIsCalculateRp] = React.useState(false);
  const [isModifyStatus, setIsModifyStatus] = React.useState(false);
  const [isUpdateBank, setIsUpdateBank] = React.useState(false);

  const [processCreditIn, { loading: loadingProcessCreditIn }] =
    useMutation(PROCESS_ONE_CREDITIN);
  const [processCreditOut, { loading: loadingProcessCreditOut }] = useMutation(
    PROCESS_ONE_CREDITOUT
  );
  const [approveOneDeposit, { loading: loadingDeposit }] =
    useMutation(APPROVE_ONE_DEPOSIT);
  const [rejectOneDeposit, { loading: loadingRejectDeposit }] =
    useMutation(REJECT_ONE_DEPOSIT);
  const [approveOneWithdrawal, { loading: loadingApproveWithdrawal }] =
    useMutation(APPROVE_ONE_WITHDRAWAL);
  const [rejectOneWithdrawal, { loading: loadingRejectWithdrawal }] =
    useMutation(REJECT_ONE_WITHDRAWAL);
  const [viewOneTransaction, { loading: loadingViewOneTransaction }] =
    useMutation(VIEW_ONE_TRANSACTION);
  const [calculateRp] = useMutation(CALCULATE_REWARD_POINT);
  const [calculateAgentPoint] = useMutation(CALCULATE_AGENT_POINT);
  const [updateOneTransaction] = useMutation(UPDATE_ONE_TRANSACTION);
  const [releasePayment] = useMutation(RELEASE_PAYMENT);

  const [updateTransactionBankAccount] = useMutation(
    CHANGE_COMPANY_BANK_ACCOUNT
  );
  const [onHoldOneTransaction] = useMutation(ON_HOLD_ONE_TRANSACTION);
  const [checkPaymentStatus] = useMutation(CHECK_PAYMENT_STATUS);
  const [checkReleasePaymentStatus] = useMutation(CHECK_RELEASE_PAYMENT_STATUS);

  const { data: meData } = useQuery(ME);

  const { data: paymentTypesData } = useQuery(GET_PAYMENT_TYPES, {
    variables: {
      filter: {
        code: {
          in: ["Bank", "FPX"],
        },
      },
    },
  });

  const { data: transactionStatusEnum } = useQuery(GET_ENUM, {
    variables: {
      name: "TransactionStatus",
    },
  });

  const { data: paymentStatusEnum } = useQuery(GET_ENUM, {
    variables: {
      name: "PaymentStatus",
    },
  });

  const ViewedTransaction = async () => {
    await viewOneTransaction({
      variables: {
        id: transaction.node.id,
      },
    }).catch((e) => {
      ToastHelper.toggleToast({
        toastType: "error",
        message: e,
        title: "",
        onClick: function () { },
      });
    });

    if (onDone) {
      onDone();
    }
  };

  const onHoldTransaction = async () => {
    await onHoldOneTransaction({
      variables: {
        id: transaction.node.id,
      },
    }).catch((e) => {
      ToastHelper.toggleToast({
        toastType: "error",
        message: e,
        title: "",
        onClick: function () { },
      });
    });

    if (onDone) {
      onDone();
    }
  };

  const checkStatus = async () => {
    await checkPaymentStatus({
      variables: {
        checkPaymentStatusInput: {
          transactionSerialNo: transaction.node.serialNo,
        },
      },
    }).catch((e) => {
      ToastHelper.toggleToast({
        toastType: "error",
        message: e,
        title: "",
        onClick: function () { },
      });
    });

    if (onDone) {
      onDone();
    }
  };

  const checkReleaseStatus = async () => {
    await checkReleasePaymentStatus({
      variables: {
        checkPaymentStatusInput: {
          transactionSerialNo: transaction.node.serialNo,
        },
      },
    }).catch((e) => {
      ToastHelper.toggleToast({
        toastType: "error",
        message: e,
        title: "",
        onClick: function () { },
      });
    });

    if (onDone) {
      onDone();
    }
  };

  const copyToClipboard = async (textToCopy) => {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(textToCopy);
    } else {
      // Use the 'out of viewport hidden text area' trick
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;

      // Move textarea out of the viewport so it's not visible
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";

      document.body.prepend(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
      } catch (error) {
        console.error(error);
      } finally {
        textArea.remove();
      }
    }
  };

  const ProcessTransaction = async () => {
    setIsDeposit(false);
    if (transaction.node.transactionType === "CreditIn") {
      await processCreditIn({
        variables: {
          id: transaction.node.id,
        },
      }).catch((e) => {
        ToastHelper.toggleToast({
          toastType: "error",
          message: e,
          title: "",
          onClick: function () { },
        });
      });
    } else if (transaction.node.transactionType === "CreditOut") {
      await processCreditOut({
        variables: {
          id: transaction.node.id,
        },
      }).catch((e) => {
        ToastHelper.toggleToast({
          toastType: "error",
          message: e,
          title: "",
          onClick: function () { },
        });
      });
    } else if (transaction.node.transactionType === "Deposit") {
      await approveOneDeposit({
        variables: {
          id: transaction.node.id,
        },
      }).catch((e) => {
        ToastHelper.toggleToast({
          toastType: "error",
          message: e,
          title: "",
          onClick: function () { },
        });
      });
    } else if (transaction.node.transactionType === "Withdrawal") {
      await approveOneWithdrawal({
        variables: {
          id: transaction.node.id,
        },
      }).catch((e) => {
        ToastHelper.toggleToast({
          toastType: "error",
          message: e,
          title: "",
          onClick: function () { },
        });
      });
    }

    if (onDone) {
      onDone();
    }
  };

  const ProcessTransactionDebounce = _.debounce(ProcessTransaction, 300);

  const RejectTransaction = async () => {
    if (transaction.node.transactionType === "Deposit") {
      await rejectOneDeposit({
        variables: {
          id: transaction.node.id,
        },
      }).catch((e) => {
        ToastHelper.toggleToast({
          toastType: "error",
          message: e,
          title: "",
          onClick: function () { },
        });
      });
    } else if (transaction.node.transactionType === "Withdrawal") {
      await rejectOneWithdrawal({
        variables: {
          id: transaction.node.id,
        },
      }).catch((e) => {
        ToastHelper.toggleToast({
          toastType: "error",
          message: e,
          title: "",
          onClick: function () { },
        });
      });
    }

    if (onDone) {
      onDone();
    }
  };

  const StatusType = () => {
    if (
      transaction.node.transactionStatus === "Pending" ||
      transaction.node.kioskStatus === "Pending"
    ) {
      return "pending";
    } else if (transaction.node.transactionStatus === "Viewed") {
      return "viewed";
    } else if (
      transaction.node.transactionStatus === "Approved" ||
      transaction.node.kioskStatus === "Completed"
    ) {
      return "created";
    } else if (
      transaction.node.transactionStatus === "Processing" ||
      transaction.node.kioskStatus === "Processing"
    ) {
      return "processing";
    } else {
      return "error";
    }
  };

  const ProcessCalculateRp = () => {
    setIsCalculateRp(false);
    if (transaction.node.rewardPoint === 0) {
      calculateRp({
        variables: {
          input: {
            transactionId: transaction.node.id,
            force: true,
          },
        },
      });
    } else {
      updateOneTransaction({
        variables: {
          input: {
            update: {
              rewardPoint: 0,
            },
            id: transaction.node.id,
          },
        },
      });
    }
  };

  const PaymentStatusColor = (status) => {
    if (status === "Paid") {
      return "created";
    } else if (status === "Failed") {
      return "error";
    } else {
      return "pending";
    }
  };

  return (
    <React.Fragment>
      <tr className="font-size-12 transactions-page" style={transaction.node.supersededById ? { textDecoration: 'line-through', opacity: 0.6 } : {}}>
        <td>
          <div className="one-line">
            {!transaction.node.player.telegramId && (
              <i className="bx bxl-chrome font-size-18 mr-2 chrome"></i>
            )}
            {transaction.node.player.telegramId && (
              <i className="bx bxl-telegram font-size-18 mr-2 telegram"></i>
            )}
            {transaction.node.serialNo}
          </div>
          {transaction.node.paymentRef && (
            <div className="one-line">{transaction.node.paymentRef}</div>
          )}
        </td>
        <td>
          <div>
            {moment(transaction.node.createdAt).format("YYYY-MM-DD HH:mm:ss")}
          </div>
          {transaction.node.createdBy && (
            <div className="text-align">
              <span className="mr-1 text-primary">
                <i className="bx bx-user font-size-20" />
              </span>
              {transaction.node.createdBy}
            </div>
          )}
        </td>
        {isFromWorkflow && (transaction.node.transactionType === "Deposit" || transaction.node.transactionType === "Withdrawal") && <td>{transaction.node.transactionType}</td>}
        {((transaction.node.transactionType !== "Deposit" &&
          transaction.node.transactionType !== "Withdrawal" &&
          transaction.node.transactionType !== "FreeCredit" &&
          transaction.node.transactionType !== "Rebate" &&
          transaction.node.transactionType !== "Bonus") ||
          type === "All") && <td>{transaction.node.transactionType}</td>}
        <td className="one-line">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="cursor-pointer" onClick={onManageInWorkbench}>
              <i className="bx bxs-wrench font-size-20 mr-2"></i>
            </div>
            {transaction.node.player.username}
            {transaction.node.player.tags.edges.length > 0 && (
              <>
                <div className="pl-1"></div>
                <i
                  className="bx bxs-info-circle text-danger font-size-16"
                  id={`tooltip-${transaction.node.id}`}
                />
                <UncontrolledTooltip
                  placement="right"
                  target={`tooltip-${transaction.node.id}`}
                >
                  {transaction.node.player.tags.edges.map((tag) => (
                    <li className="align-left">
                      {tag.node.tagType === "Good" && (
                        <i className="bx bx-check font-size-18 text-success mr-1" />
                      )}
                      {tag.node.tagType === "Neutral" && (
                        <i className="bx bxs-circle font-size-10 text-white ml-1 mr-2 mt-1" />
                      )}
                      {tag.node.tagType === "Bad" && (
                        <i className="bx bx-x font-size-18 text-danger mr-1" />
                      )}
                      {tag.node.name}
                    </li>
                  ))}
                </UncontrolledTooltip>
              </>
            )}
            {transaction.node.transactionType === "Withdrawal" &&
              transaction.node.player.lastDepositAt && (
                <>
                  <div className="pl-1"></div>
                  <i
                    className="bx bxs-dollar-circle text-success font-size-16"
                    id={`tooltip_withdrawal-${transaction.node.id}`}
                  />
                  <UncontrolledTooltip
                    placement="right"
                    target={`tooltip_withdrawal-${transaction.node.id}`}
                  >
                    <li className="align-left font-size-10">Last Deposit</li>
                    <li className="align-left text-success font-size-12">
                      ${transaction.node.player.lastDepositAmount}
                    </li>
                    <li className="align-left text-success font-size-12">
                      {moment(transaction.node.player.lastDepositAt).format(
                        "YYYY-MM-DD HH:mm"
                      )}
                    </li>
                  </UncontrolledTooltip>
                </>
              )}
          </div>
        </td>
        <td>{transaction.node.player.name}</td>
        {(isFromWorkflow || transaction.node.transactionType === "Deposit" ||
          transaction.node.transactionType === "Withdrawal" ||
          type === "All") && (
            <td>
              {transaction.node.receiptUrl ? (
                <Zoom>
                  <img alt="img" src={transaction.node.receiptUrl} height="40" />
                </Zoom>
              ) : Admin.includes(meData.me.role) ||
                Developer.includes(meData.me.role) ? (
                <>
                  {transaction.node.paymentDetails ? (
                    <>
                      <div
                        id={`payment-details-${transaction.node.id}`}
                        className="cursor-pointer status-container"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "5px",
                        }}
                        onClick={() => {
                          copyToClipboard(transaction.node.paymentDetails);
                          ToastHelper.toggleToast({
                            toastType: "success",
                            message: "Payment Details Copied",
                            title: "",
                            onClick: function () { },
                          });
                        }}
                      >
                        <i className="bx bx-copy"></i>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 2,
                            alignItems: "center",
                          }}
                        >
                          <div>Gateway Status:</div>
                          <div
                            className={PaymentStatusColor(
                              transaction.node.paymentStatus
                            )}
                            style={{
                              display: "flex",
                            }}
                          >
                            {transaction.node.paymentStatus}
                          </div>
                        </div>
                      </div>
                      <UncontrolledTooltip
                        style={{
                          position: "relative",
                          maxWidth: "300px",
                          width: "300px",
                        }}
                        placement="right"
                        target={`payment-details-${transaction.node.id}`}
                      >
                        <div
                          style={{
                            maxWidth: "280px",
                            width: "280px",
                            wordWrap: "break-word",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {/* <div className="align-left">
                          {`• Transaction No: ${transaction.node.serialNo}`}
                        </div>
                        <div className="align-left">
                          {`• Message: ${JSON.stringify(
                            JSON.parse(transaction.node.paymentDetails),
                            null,
                            "\t"
                          )}`}
                        </div> */}
                          {`${JSON.stringify(
                            JSON.parse(transaction.node.paymentDetails),
                            null,
                            "\t"
                          )}`}
                        </div>
                      </UncontrolledTooltip>
                    </>
                  ) : (
                    <div>-</div>
                  )}
                </>
              ) : (
                "-"
              )}
            </td>
          )}
        {(transaction.node.transactionType === "Deposit" || type === "All") && !isFromWorkflow && (
          <>
            <td>{transaction.node.amount}</td>
            <td className="align-left">
              {transaction.node.bonusAmount}
              {transaction.node.bonus && transaction.node.bonus.name && (
                <>
                  <div className="pl-1"></div>
                  <i
                    className="bx bxs-info-circle text-info font-size-16"
                    id={`bonus-${transaction.node.id}`}
                  />
                  <UncontrolledTooltip
                    placement="right"
                    target={`bonus-${transaction.node.id}`}
                  >
                    <li className="align-left">
                      {transaction.node.bonus.name}
                    </li>
                  </UncontrolledTooltip>
                </>
              )}
            </td>
          </>
        )}
        {(type === "FreeCredit" || type === "Rebate") && (
          <>
            <td>{transaction.node.amount}</td>
          </>
        )}
        <td>{transaction.node.totalAmount}</td>
        {isAtDashboard && transaction.node.transactionType === "Deposit" && (
          <td className="one-line">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <div>{transaction.node.rewardPoint}</div>
              {(transaction.node.transactionStatus === "Pending" ||
                transaction.node.transactionStatus === "Viewed") &&
                transaction.node.rewardPoint === 0 && (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setIsCalculateRp(true);
                    }}
                  >
                    <i className="bx bx-calculator font-size-18 ml-1 text-success"></i>
                  </div>
                )}
              {transaction.node.rewardPoint > 0 && (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setIsCalculateRp(true);
                  }}
                >
                  <i className="bx bx-x font-size-18 ml-1 text-danger"></i>
                </div>
              )}
            </div>
          </td>
        )}
        {isAtDashboard && transaction.node.transactionType === "Deposit" && (
          <td className="one-line">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <div>
                {parseFloat(transaction.node.agentPoint).toFixed(2).toString()}
              </div>
              {(transaction.node.transactionStatus === "Pending" ||
                transaction.node.transactionStatus === "Viewed") &&
                transaction.node.agentPoint === 0 &&
                transaction.node.player.upline && (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      calculateAgentPoint({
                        variables: {
                          input: {
                            transactionId: transaction.node.id,
                          },
                        },
                      });
                    }}
                  >
                    <i className="bx bx-calculator font-size-18 ml-1 text-success"></i>
                  </div>
                )}
              {transaction.node.agentPoint > 0 && (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    updateOneTransaction({
                      variables: {
                        input: {
                          update: {
                            agentPoint: 0,
                          },
                          id: transaction.node.id,
                        },
                      },
                    });
                  }}
                >
                  <i className="bx bx-x font-size-18 ml-1 text-danger"></i>
                </div>
              )}
            </div>
            {transaction.node.player.upline && (
              <div className="text-align">
                <span className="mr-1 text-primary">
                  <i className="bx bx-user font-size-20" />
                </span>
                {transaction.node.player.upline.username}
              </div>
            )}
          </td>
        )}
        {(transaction.node.transactionType === "CreditIn" ||
          transaction.node.transactionType === "CreditOut") && (
            <>
              <td>
                {transaction.node.movement ? transaction.node.movement : "N/A"}
              </td>
              <td>
                {transaction.node.kioskRemark
                  ? transaction.node.kioskRemark
                  : "N/A"}
              </td>
            </>
          )}
        {(transaction.node.transactionType === "Deposit" ||
          transaction.node.transactionType === "Bonus" ||
          transaction.node.transactionType === "FreeCredit" ||
          transaction.node.transactionType === "Rebate") && (
            <>
              <td>
                <div className="space-between">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <div>
                      {transaction.node.movement
                        ? transaction.node.movement
                        : "N/A"}
                    </div>
                    <div>{transaction.node.paymentGatewayProviderCode}</div>
                  </div>
                  {transaction.node.transactionStatus === "Approved" && (
                    <>
                      <div className="ml-2"></div>
                      <i
                        className="bx bxs-message-square-edit text-warning font-size-18 cursor-pointer"
                        onClick={() => {
                          setIsUpdateBank(true);
                        }}
                      />
                    </>
                  )}
                </div>
              </td>
            </>
          )}
        {meData &&
          !OperatingUsers.includes(meData.me.role) &&
          transaction.node.transactionType === "Withdrawal" && (
            <>
              <td>
                <div className="space-between">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <div>
                      {transaction.node.movement
                        ? transaction.node.movement
                        : "N/A"}
                    </div>
                    <div>{transaction.node.paymentGatewayProviderCode}</div>
                  </div>
                  {transaction.node.transactionStatus === "Approved" && (
                    <>
                      <div className="ml-2"></div>
                      <i
                        className="bx bxs-message-square-edit text-warning font-size-18 cursor-pointer"
                        onClick={() => {
                          setIsUpdateBank(true);
                        }}
                      />
                    </>
                  )}
                </div>
              </td>
            </>
          )}
        {isFromWorkflow && (transaction.node.transactionType === "Deposit" || transaction.node.transactionType === "Withdrawal") && (
          <>
            <td>
              {transaction.node.kioskRemark
                ? transaction.node.kioskRemark
                : "N/A"}
            </td>
          </>
        )}
        {(type === "FreeCredit" || type === "Rebate") && (
          <>
            {!transaction.node.freeCreditType && !transaction.node.bonus && (
              <td>-</td>
            )}
            {transaction.node.freeCreditType && (
              <td>{transaction.node.freeCreditType.name}</td>
            )}
            {transaction.node.bonus && <td>{transaction.node.bonus.name}</td>}
          </>
        )}
        {showReject &&
          transaction.node.transactionType !== "CreditIn" &&
          transaction.node.transactionType !== "CreditOut" && (
            <>
              <td>
                {transaction.node.rejectReason
                  ? transaction.node.rejectReason.name
                  : ""}
              </td>
              <td>{transaction.node.rejectRemark}</td>
            </>
          )}
        {
          <td>
            <div>
              <div>
                {moment(transaction.node.updatedAt).format(
                  "YYYY-MM-DD HH:mm:ss"
                )}
              </div>
              {transaction.node.updatedBy && (
                <div className="text-align">
                  <span className="mr-1 text-primary">
                    <i className="bx bx-user font-size-20" />
                  </span>
                  {transaction.node.updatedBy}
                </div>
              )}
            </div>
          </td>
        }
        {hasPaidAt && (
          <td>
            <div>
              <div>
                {moment(transaction.node.paidAt).format("YYYY-MM-DD HH:mm:ss")}
              </div>
            </div>
          </td>
        )}
        <td>
          <div className="space-between" style={{ gap: "8px" }}>
            <div className="pr-2">
              <div className="status-container">
                <div className={StatusType()}>
                  {transaction.node.transactionStatus
                    ? transaction.node.transactionStatus
                    : transaction.node.kioskStatus}
                </div>
              </div>
            </div>
            {!transaction.node.supersededById && (
              <>
                {(transaction.node.kioskStatus === "Failed" ||
                  transaction.node.kioskStatus === "Processing") && (
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light font-size-11 align-center"
                      onClick={ProcessTransactionDebounce}
                    >
                      {(loadingProcessCreditIn || loadingProcessCreditOut) && (
                        <>
                          <i className="fas fa-spinner fa-spin font-size-14 align-middle"></i>
                          <div className="pl-1"></div>
                        </>
                      )}
                      <div>Retry</div>
                    </button>
                  )}
                {(transaction.node.transactionStatus === "Approved" ||
                  transaction.node.kioskStatus === "Completed") &&
                  !transaction.node.paymentStatus &&
                  meData &&
                  meData.me.role === "Developer" && (
                    <button
                      type="button"
                      className="btn btn-danger waves-effect waves-light font-size-11 align-center"
                      onClick={onDelete}
                    >
                      {/* {
                                        (loadingDeleteTranaction) &&
                                        <>
                                            <i className="fas fa-spinner fa-spin font-size-14 align-middle"></i>
                                            <div className="pl-1"></div>
                                        </>
                                    } */}
                      <div>Delete</div>
                    </button>
                  )}
                {((transaction.node.transactionStatus === "Pending" ||
                  transaction.node.transactionStatus === "OnHold" ||
                  transaction.node.kioskStatus === "Pending" ||
                  transaction.node.transactionStatus === "Viewed" ||
                  transaction.node.transactionStatus === "ReadyToRelease") ||
                  (meData &&
                    Developer.includes(meData.me.role) &&
                    (transaction.node.transactionStatus === "Rejected" ||
                      transaction.node.paymentStatus === "Failed"))) &&
                  transaction.node.transactionStatus !== "Approved" && (
                    <ButtonDropdown
                      isOpen={drp_link}
                      toggle={() => setDrpLink(!drp_link)}
                    >
                      <DropdownToggle
                        className="font-size-11 align-center"
                        caret
                        color="secondary"
                      >
                        {(loadingProcessCreditIn ||
                          loadingProcessCreditOut ||
                          loadingDeposit ||
                          loadingRejectDeposit ||
                          loadingApproveWithdrawal ||
                          loadingRejectWithdrawal ||
                          loadingViewOneTransaction) && (
                            <>
                              <i className="fas fa-spinner fa-spin font-size-14 align-middle"></i>
                              <div className="pl-1"></div>
                            </>
                          )}
                        Actions <i className="mdi mdi-chevron-down"></i>
                      </DropdownToggle>
                      <DropdownMenu right container="body">
                        {transaction.node.paymentStatus &&
                          transaction.node.transactionStatus !== "Rejected" &&
                          (
                            <DropdownItem
                              className="font-size-11"
                              onClick={
                                transaction.node.transactionType === "Withdrawal"
                                  ? checkReleaseStatus
                                  : checkStatus
                              }
                            >
                              Check Status
                            </DropdownItem>
                          )}
                        {!(
                          transaction.node.transactionStatus === "OnHold" ||
                          transaction.node.transactionType === "CreditIn" ||
                          transaction.node.transactionType === "CreditOut" ||
                          transaction.node.transactionStatus === "Viewed"
                        ) &&
                          !transaction.node.paymentStatus && (
                            <DropdownItem
                              className="font-size-11"
                              onClick={ViewedTransaction}
                            >
                              Mark Viewed
                            </DropdownItem>
                          )}
                        {meData &&
                          (Admin.includes(meData.me.role) ||
                            Developer.includes(meData.me.role)) &&
                          !(
                            transaction.node.transactionType === "CreditIn" ||
                            transaction.node.transactionType === "CreditOut" ||
                            transaction.node.transactionStatus === "OnHold"
                          ) &&
                          !transaction.node.paymentStatus && (
                            <DropdownItem
                              className="font-size-11"
                              onClick={onHoldTransaction}
                            >
                              On Hold
                            </DropdownItem>
                          )}
                        {transaction.node.transactionStatus !== "Rejected" && (
                          <DropdownItem
                            className="font-size-11"
                            onClick={() => {
                              if (transaction.node.transactionType === "Withdrawal") {
                                setIsWithdrawal(true);
                              } else {
                                setIsDeposit(true);
                              }
                            }}
                          >
                            Approve
                          </DropdownItem>
                        )}
                        {transaction.node.transactionStatus !== "Rejected" && (
                          <DropdownItem
                            className="font-size-11"
                            onClick={() => setIsReject(true)}
                          >
                            Reject
                          </DropdownItem>
                        )}
                        {meData &&
                          Developer.includes(meData.me.role) &&
                          transaction.node.paymentStatus && (
                            <DropdownItem
                              className="font-size-11"
                              onClick={() => setIsModifyStatus(true)}
                            >
                              Modify Status
                            </DropdownItem>
                          )}
                        {meData &&
                          allowSupersede && (
                            <DropdownItem
                              className="font-size-11"
                              onClick={() => onSupersede(transaction.node)}
                            >
                              Supersede
                            </DropdownItem>
                          )}
                      </DropdownMenu>
                    </ButtonDropdown>
                  )}
              </>
            )}
          </div>
        </td>
      </tr>
      {transaction && (
        <WithdrawBank
          modal={isWithdrawal}
          transaction={transaction.node}
          toggleModal={() => setIsWithdrawal(!isWithdrawal)}
          onDone={async (
            values,
            receipt,
            withdrawalMethod,
            paymentGatewayId
          ) => {
            const paymentType = paymentTypesData.paymentTypes.edges.find(
              (d) => d.node.code === withdrawalMethod
            );
            if (withdrawalMethod === "Bank") {
              await updateOneTransaction({
                variables: {
                  input: {
                    update: {
                      companyBankAccountId: values.bank,
                      amount: parseFloat(values.amount),
                      totalAmount: parseFloat(values.amount),
                      receiptUrl: receipt,
                      paymentTypeId: paymentType.node.id,
                    },
                    id: transaction.node.id,
                  },
                },
              })
                .then((val) => {
                  if (val) {
                    ToastHelper.toggleToast({
                      message: "Update Succesfully!",
                      title: "",
                      onClick: function () { },
                    });
                  }
                })
                .catch((e) => {
                  ToastHelper.toggleToast({
                    toastType: "error",
                    message: e,
                    title: "",
                    onClick: function () { },
                  });
                });
              await ProcessTransactionDebounce();
            } else if (withdrawalMethod === "FPX") {
              await updateOneTransaction({
                variables: {
                  input: {
                    update: {
                      paymentTypeId: paymentType.node.id,
                      paymentGatewayId: paymentGatewayId,
                    },
                    id: transaction.node.id,
                  },
                },
              })
                .then(async () => {
                  releasePayment({
                    variables: {
                      transactionSerialNo: transaction.node.serialNo,
                    },
                  })
                    .then((val) => {
                      if (val) {
                        ToastHelper.toggleToast({
                          message: "Payment Submitted for Release!",
                          title: "",
                          onClick: function () { },
                        });
                      }
                    })
                    .catch((e) => {
                      ToastHelper.toggleToast({
                        toastType: "error",
                        message: e,
                        title: "",
                        onClick: function () { },
                      });
                    });
                })
                .catch((e) => {
                  ToastHelper.toggleToast({
                    toastType: "error",
                    message: e,
                    title: "",
                    onClick: function () { },
                  });
                });
            }
            setIsWithdrawal(!isWithdrawal);
          }}
        />
      )}
      {transaction && isReject && (
        <TransactionReject
          modal={isReject}
          transaction={transaction.node}
          toggleModal={() => setIsReject(!isReject)}
          onDone={async (values) => {
            await updateOneTransaction({
              variables: {
                input: {
                  update: {
                    rejectRemark: values.remark,
                    rejectReasonId: values.reason,
                  },
                  id: transaction.node.id,
                },
              },
            })
              .then((val) => {
                if (val) {
                  ToastHelper.toggleToast({
                    message: "Update Succesfully!",
                    title: "",
                    onClick: function () { },
                  });
                }
              })
              .catch((e) => {
                ToastHelper.toggleToast({
                  toastType: "error",
                  message: e,
                  title: "",
                  onClick: function () { },
                });
              });
            await RejectTransaction();
            setIsReject(!isReject);
          }}
        />
      )}
      {transaction && isUpdateBank && (
        <TransactionChangeBank
          modal={isUpdateBank}
          transaction={transaction}
          toggleModal={() => {
            setIsUpdateBank(false);
          }}
          onDone={async (values) => {
            setIsUpdateBank(false);
            await updateTransactionBankAccount({
              variables: {
                companyBankAccountId: values.bank,
                id: transaction.node.id,
              },
            })
              .then((val) => {
                if (val) {
                  ToastHelper.toggleToast({
                    message: "Update Succesfully!",
                    title: "",
                    onClick: function () { },
                  });
                }
              })
              .catch((e) => {
                ToastHelper.toggleToast({
                  toastType: "error",
                  message: e,
                  title: "",
                  onClick: function () { },
                });
              });
          }}
        />
      )}
      {isDepost && (
        <SweetAlert
          warning
          showCancel
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="primary"
          title={"Confirm Approve Transaction?"}
          onConfirm={ProcessTransactionDebounce}
          onCancel={() => setIsDeposit(false)}
        />
      )}
      {isCalculateRp && (
        <SweetAlert
          warning
          showCancel
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="primary"
          title={
            transaction.node.rewardPoint === 0
              ? "Confirm Recalculate RP?"
              : "Confirm Remove RP?"
          }
          onConfirm={ProcessCalculateRp}
          onCancel={() => setIsCalculateRp(false)}
        />
      )}
      {isModifyStatus && (
        <Modal
          isOpen={isModifyStatus}
          role="dialog"
          size="md"
          autoFocus={true}
          centered={true}
          id="modifyStatusModal"
          tabIndex="-1"
          toggle={() => setIsModifyStatus(false)}
        >
          <div className="modal-content">
            <ModalHeader toggle={() => setIsModifyStatus(false)}>
              Modify Transaction Status
            </ModalHeader>
            <ModalBody>
              <AvForm
                className="needs-validation"
                onValidSubmit={(event, values) => {
                  const updateData = {};
                  if (values.transactionStatus) {
                    updateData.transactionStatus = values.transactionStatus;
                  }
                  if (values.paymentStatus) {
                    updateData.paymentStatus = values.paymentStatus;
                  }
                  updateOneTransaction({
                    variables: {
                      input: {
                        update: updateData,
                        id: transaction.node.id,
                      },
                    },
                  })
                    .then((val) => {
                      if (val) {
                        ToastHelper.toggleToast({
                          message: "Status Updated Successfully!",
                          title: "",
                          onClick: function () { },
                        });
                        setIsModifyStatus(false);
                        if (onDone) {
                          onDone();
                        }
                      }
                    })
                    .catch((e) => {
                      ToastHelper.toggleToast({
                        toastType: "error",
                        message: e,
                        title: "",
                        onClick: function () { },
                      });
                    });
                }}
              >
                <Row>
                  <Col lg="12">
                    <div className="mb-3">
                      <strong>Serial No:</strong> {transaction.node.serialNo}
                    </div>
                    <div className="mb-3">
                      <strong>Current Transaction Status:</strong>{" "}
                      <span className={StatusType()}>
                        {transaction.node.transactionStatus}
                      </span>
                    </div>
                    {transaction.node.paymentStatus && (
                      <div className="mb-3">
                        <strong>Current Payment Status:</strong>{" "}
                        <span
                          className={PaymentStatusColor(
                            transaction.node.paymentStatus
                          )}
                        >
                          {transaction.node.paymentStatus}
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col lg="12">
                    <AvField
                      label="Transaction Status"
                      type="select"
                      name="transactionStatus"
                      className="custom-select"
                      value={transaction.node.transactionStatus}
                    >
                      {transactionStatusEnum &&
                        transactionStatusEnum.__type.enumValues.map(
                          ({ name }, index) => (
                            <option key={index} value={name}>
                              {name}
                            </option>
                          )
                        )}
                    </AvField>
                  </Col>
                  <Col lg="12">
                    <AvField
                      label="Payment Status"
                      type="select"
                      name="paymentStatus"
                      className="custom-select"
                      value={transaction.node.paymentStatus || ""}
                    >
                      <option value="">-- Select --</option>
                      {paymentStatusEnum &&
                        paymentStatusEnum.__type.enumValues.map(
                          ({ name }, index) => (
                            <option key={index} value={name}>
                              {name}
                            </option>
                          )
                        )}
                    </AvField>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end mt-3">
                  <Button
                    color="secondary"
                    className="mr-2"
                    onClick={() => setIsModifyStatus(false)}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" type="submit">
                    Update Status
                  </Button>
                </div>
              </AvForm>
            </ModalBody>
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
}

export default TransactionItem;
